import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "x",
  "use": "x-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"x\"><g class=\"is-icon-target\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(6 6)\"><path d=\"m12 0-12 12\" /><path d=\"m0 0 12 12\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol